import {
    RESET_CART,
    START_ORDER,
    FETCH_UPSELLS_DATA,
    TRIGGER_UPSELL,
    END_UPSELL,
} from '../actions/types';
import { getStorage, setStorage } from '../cache';

const INITIAL_STATE = {
    categories: {},
    items: {},
    translations: {},
    upsells: {},
    ...getStorage().catalog || {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_CART: {
            setStorage({ catalog: null });
            return INITIAL_STATE;
        }
        case START_ORDER: {
            const { catalog } = action.payload;
            setStorage({ catalog });

            return { ...state, ...catalog };
        }
        case FETCH_UPSELLS_DATA: {
            if (!action.payload || !action.payload.length) {
                return state;
            }

            const upsell = state.upsells[action.meta.trigger] || { triggerStatus: 'pending' };
            upsell.categories = action.payload;

            return { ...state, upsells: { ...state.upsells, [action.meta.trigger]: upsell } };
        }
        case TRIGGER_UPSELL: {
            if (!state.upsells[action.payload] || state.upsells[action.payload].triggerStatus === 'ended') return state;

            const upsell = { ...state.upsells[action.payload], triggerStatus: 'active' };

            return { ...state, upsells: { ...state.upsells, [action.payload]: upsell } };
        }
        case END_UPSELL: {
            if (!state.upsells[action.payload]) return state;

            const upsell = { ...state.upsells[action.payload] };
            upsell.categories = upsell.categories.filter(c => c.options.isRepeatable);
            upsell.triggerStatus = upsell.categories.length ? 'pending' : 'ended';

            return { ...state, upsells: { ...state.upsells, [action.payload]: upsell } };
        }
        default:
            return state;
    }
};
